import axios, { AxiosRequestConfig } from 'axios'
import { getAuth, clearAuth } from './auth'

export const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
})

api.interceptors.request.use(
	async (config: AxiosRequestConfig) => {
		const token = getAuth()
		if (token && config.headers) {
			config.headers.Authorization = `Bearer ${token}`
		}
		return config
	},
	error => Promise.reject(error),
)

api.interceptors.response.use(
	response => response,
	error => {
		const accessToken = getAuth()
		if (error.response.status === 401 && accessToken) {
			clearAuth()
		}
		return Promise.reject(error)
	},
)

export default api
